import React from 'react'
import widgetService from 'live/services/widgets'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import { KPIWidgetsState, KPIWidgetsMessage, KPIWidgetsConfig } from './types'
import { reducer } from './PanelWidgetReducer'
import { name, description, type, queryHandlerKind } from './utils'
import { withSuspenseWrapper } from '../../SuspenseWrapper'

const WrapperWidget = withSuspenseWrapper(React.lazy(() => import('./PanelWidget')))

widgetService.register({
    type,
    name,
    description,
    queryHandlerKind,
    config: {
        panels: []
    },
    policies: {
        handleOwnMissingData: true
    },
    impl: reactWidgetWrapper<KPIWidgetsState, KPIWidgetsMessage, KPIWidgetsConfig>(WrapperWidget, reducer)
})
